<div class="processor-page-container">
    <ng-container *ngFor="let panel of panelData; let i = index">
    <section *ngIf="panel.panelType === ptlPanel">
        <div id="ptlpanel_{{i+1}}" style="background: #ffffff;" >
            <div id="ptl12xePreTitle" *ngIf="i==0 && isPtl12Xe" class="ptl12xe-panel1-pretitle"  [class.intelOne-display]="setFontIntelDisplayOne" [innerHTML]="panel.pretitle"></div>
            <div class="ptlpanel" [ngClass]="i==1 ? 'ptl_panel2' : ''" style="background-image: url({{panel.detailBgUrl}});">
                <img class="ptl_bgImage" [src]="panel.detailBgUrl" alt="ptl_pane_bg">
                <div class="ptlPanelcontent">
                    <div id="ptlPanelTitle" class="ptl_panel_title" [ngClass]="i==0 ? 'white_color_title' : ''"  [innerHTML]="panel.title"></div>
                    <div class="card_content">
                        <div id="ptlPanelSubtitle" *ngIf="panel.subtitle" class="ptl_panel_subtitle"  [class.intelOne-display]="setFontIntelDisplayOne" [ngClass]="[i==0 ? 'white_color_title' : '', !isPtl12Xe && i==0 ? 'regular_ptl_subtitle' : '', i==1 ? 'second-panel-width' : '']"  [innerHTML]="panel.subtitle"></div>
                        </div>
                    <div id="ptl_pane1_badges" *ngIf="panel.badgeUrl && panel.badgeUrl1" [ngClass]="!isPtl12Xe ? 'regular-ptl': ''" class="ptl-panel-badge">
                        <img *ngIf="panel.badgeUrl" [src]="panel.badgeUrl" alt="proc_badge">
                        <div class="inline_separator"></div>
                        <img *ngIf="panel.badgeUrl1" [src]="panel.badgeUrl1" alt="proc2_badge">
                    </div>
                    <div id="panther_card_info" class="card_content">                        
                        <div *ngIf="panel.titleArray" class="ptl-card-info card" [ngClass]="[i==0 ? 'white_color_title' : '', i==1 ? 'second-card-width' : '']">
                            <ul  *ngFor="let item of panel.titleArray">
                                <li  [class.intelOne-display]="setFontIntelDisplayOne" [innerHTML]="item.tr_title"></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="panel.badgeIcons" class="ptlcarousel">
                <div class="carousel-container">
                    <div class="carousel-card" *ngFor="let item of panel.badgeIcons" style="background-image: url({{item.imgUrl}});">
                        <div class="card-text" [ngClass]="whiteText(item.imgUrl)" [innerHTML]="item.tr_badgeTitle"></div>
                    </div>
                </div>
            </div>
            <div id="ptlPanelLegal" *ngIf="panel.subtitle2" class="ptl_legal">
                <div class="ptl_panel_legal"  [class.intelOne-display]="setFontIntelDisplayOne" [innerHTML]="panel.subtitle2"></div>
            </div>
        </div>

    </section>
</ng-container>
</div>